const mediaItems = [
  {
    title: '《锦绣芳华》大结局预告',
    desc: '宫廷风云再起，一切恩怨将在大结局揭晓',
    duration: '02:35',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20palace%20drama%20trailer%20moment%20with%20warm%20golden%20lighting%2C%20dramatic%20composition%2C%20flowing%20silk%20robes%2C%20palace%20interior%20with%20lanterns%2C%20film%20poster%20aesthetic%2C%20rich%20orange%20and%20gold%20tones&width=640&height=360&seq=juzi-media-01&orientation=landscape',
  },
  {
    title: '《暗夜追击》幕后花絮',
    desc: '主演畅谈角色塑造，揭秘悬疑剧拍摄幕后故事',
    duration: '05:18',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20crime%20drama%20filming%20with%20warm%20studio%20lighting%2C%20camera%20equipment%2C%20director%20chair%2C%20cinematic%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20professional%20film%20production%20setting&width=640&height=360&seq=juzi-media-02&orientation=landscape',
  },
  {
    title: '2026 暑期档新剧速览',
    desc: '一分钟看完本季所有新上剧集，追剧清单必备',
    duration: '01:42',
    image: 'https://readdy.ai/api/search-image?query=Summer%20drama%20collection%20showcase%20with%20warm%20vibrant%20colors%2C%20film%20strip%20collage%20effect%2C%20cinematic%20montage%20aesthetic%2C%20orange%20and%20gold%20accents%2C%20dynamic%20composition%2C%20modern%20streaming%20platform%20visual&width=640&height=360&seq=juzi-media-03&orientation=landscape',
  },
  {
    title: '《未来之城 2049》视觉解析',
    desc: '特效团队详解科幻巨制背后的视觉技术突破',
    duration: '08:12',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20visual%20effects%20breakdown%20with%20holographic%20displays%20and%20neon%20orange%20accents%2C%20sci-fi%20laboratory%20setting%2C%20digital%20interfaces%2C%20cinematic%20cyberpunk%20aesthetic%2C%20warm%20golden%20highlights%2C%20clean%20futuristic%20design&width=640&height=360&seq=juzi-media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-vidicon-line text-sm w-4 h-4 flex items-center justify-center"></i>
            精彩视频
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">预告与花絮</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">热门剧集预告片、幕后花絮与独家专访内容抢先看。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl w-5 h-5 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-background-950/70 text-background-50 text-[10px] font-mono backdrop-blur-sm whitespace-nowrap">{item.duration}</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}